import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/minimal/Card';

const MinimalDirectory: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="space-y-8">
            <h2 className="text-sm font-bold uppercase tracking-widest">/ls</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Card title="Projects" description="Engineering & Research Portfolio." onClick={() => navigate('/projects')} />
                <Card title="Publications" description="Research papers and proceedings." onClick={() => navigate('/publications')} />
                <Card title="Strava" description="Athletic data and route mapping." onClick={() => navigate('/strava')} />
                <Card title="CLI Tools" description="Personal hardware automation scripts." onClick={() => navigate('/cli')} />
                <Card title="Weather" description="Ambient environmental sensor data." onClick={() => navigate('/weather')} />
                <Card title="ParkQR" description="Parking ticket QR recovery." onClick={() => navigate('/parkqr')} />
            </div>
        </div>
    );
};

export default MinimalDirectory;
